import { render, staticRenderFns } from "./Outbound.vue?vue&type=template&id=50d1b293&scoped=true&"
import script from "./Outbound.vue?vue&type=script&lang=js&"
export * from "./Outbound.vue?vue&type=script&lang=js&"
import style0 from "./Outbound.vue?vue&type=style&index=0&id=50d1b293&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d1b293",
  null
  
)

export default component.exports